{
  "Accessibility Menu": "Hozzáférhetőségi menü",
  "Reset settings": "Beállítások visszaállítása",
  "Close": "Bezárás",
  "Content Adjustments": "Tartalom beállításai",
  "Adjust Font Size": "Betűméret beállítása",
  "Highlight Title": "Cím kiemelése",
  "Highlight Links": "Linkek kiemelése",
  "Readable Font": "Olvasható betűtípus",
  "Color Adjustments": "Színbeállítások",
  "Dark Contrast": "Sötét kontraszt",
  "Light Contrast": "Világos kontraszt",
  "High Contrast": "Magas kontraszt",
  "High Saturation": "Magas telítettség",
  "Low Saturation": "Alacsony telítettség",
  "Monochrome": "Monokróm",
  "Tools": "Eszközök",
  "Reading Guide": "Olvasási útmutató",
  "Stop Animations": "Animációk leállítása",
  "Big Cursor": "Nagy kurzor",
  "Increase Font Size": "Betűméret növelése",
  "Decrease Font Size": "Betűméret csökkentése",
  "Letter Spacing": "Betűtávolság",
  "Line Height": "Sor magasság",
  "Font Weight": "Betűtípus vastagsága",
  "Dyslexia Font": "Dyslexia betűtípus",
  "Language": "Nyelv",
  "Open Accessibility Menu": "Hozzáférhetőségi menü megnyitása"
}
